import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioSupportUtils from "../common/support_utils.js";

export class New_venOsSupportModel extends IllumioEventEmitter {
    constructor() {
        super();

        // this.dataLoadEvent = new Event(this);
        let url = '/api/v1/pce_software/os_support/ven.json'
        if (IllumioSupportUtils.isPublicResource()) {
            url = '/api/v1/shared/pce_software/os_support/ven.json'
        }
        $.ajax({
            dataType: 'json',
            method: 'get',
            contentType: 'application/json; charset=utf-8',
            url: url,
            error: this.ajaxErrorHandler.bind(this),
            success: this.ajaxSuccessHandler.bind(this),
        });
    }

    ajaxSuccessHandler(response, textStatus, jqXHR) {
        console.debug('ajaxSuccessHandler() invoked.');
        if (response && response.data) {
            this.success = true;
            this.data = response.data;
            // this.dataLoadEvent.notify();
            this.emit('dataLoad', {});
        } else {
            this.success = false;
            this.error = response.error;
        }
    }

    ajaxErrorHandler() {
        console.warn('ajaxErrorHandler() invoked.');
        const result = new New_venOsSupportResult();
        result.renderError(null);
    };

        /**
         * Public method
         */
        getRecordsByVersions() {
            const records = [];
            if (this.data['os_content']) {
                for (let id in this.data['os_content']) {
                    for (let i = 0; i < venVersions.length; i++) {
                        if (this.data['os_content'][id].software_version===venVersions[i]) {
                            records.push(this.data['os_content'][id]);
                        }
                    }
                }
            }
            console.log('records', records);

            return records;
        }
}

export class New_venOsSupportView extends IllumioEventEmitter {
    constructor(model) {
        super();

        this.model = model;
        this.formDiv = document.getElementById('formDiv');
        this.new_venVersionSelect = document.getElementById('new_venVersionSelect');
        this.new_venVersionSelect.onchange = this.new_venVersionSelectOnChangeHandler.bind(this);

        this.new_venOsSelect = document.getElementById('new_venOsSelect');

        this.venVersionDiv = document.getElementById('venVersionDiv');
        this.venVersionSelect = document.getElementById('venVersionSelect');

        //this.new_venVersionSelect.onchange = new_venOsSelectOnChangeHandler.bind(this);
        if (model) {
            this.model = model;
            console.log('this.model',this.model);
            // this.model.dataLoadEvent.attach(populateVenVersionSelect.bind(this));
            // this.model.dataLoadEvent.attach(populateVenOsSelect.bind(this));
            this.model.on('dataLoad', this.populateVenVersionSelect.bind(this));
            this.model.on('dataLoad', this.populateVenOsSelect.bind(this));
        }

        //this.model.dataLoadEvent.attach(dataLoadEventHandler.bind(this));

        this.result = new New_venOsSupportResult();
    }

        /**
         * Public method
         */
        showResult(id) {
            if (!id && this.new_venVersionSelect && this.new_venVersionSelect.options.selectedIndex>=0) {
                id = this.new_venVersionSelect.options[this.new_venVersionSelect.options.selectedIndex].value;
            }

            console.debug(`selected id: ${id}`);
            this.result.render(this.model.data['os_content'][id], this.model.data['compatibility'][this.model.data['os_content'][id]['software_version']]);

            location.hash = this.model.data['os_content'][id].software_version;

            this.trackAnalytic();
        }

    new_venVersionSelectOnChangeHandler(event) {
        console.debug('new_venVersionSelectOnChangeHandler() invoked');
        this.showResult(event.target.value);
    }

    dataLoadEventHandler(event) {
        console.debug('dataLoadEventHandler() invoked!');
        if (this.model.success && this.model.data['os_content']) {
            let itemCounter = 0;
            let optionsArray = new Array();
            for (let id in this.model.data['os_content']) {
                const item = this.model.data['os_content'][id];
                console.log('item', item);

                let text = item.software_version;
                if (item.lts) {
                    text += ' (LTS)';
                }

                optionsArray.push(new Option(text, item.id));
            }
            if (optionsArray.length>0) {
                const optionsArraySortHandler = function(a, b) {
                    if (a.text>b.text) {
                        return -1;
                    } else if (a.text<b.text) {
                        return 1;
                    }
                    return 0;
                }
                optionsArray.sort(optionsArraySortHandler);

                const optionsArrayForEachHandler = function(optionItem) {
                    console.debug(optionItem);
                    console.debug(this);
                    this.new_venVersionSelect.options.add(optionItem);
                }
                optionsArray.forEach(optionsArrayForEachHandler, this);
            }
            if (this.new_venVersionSelect.options.length>0) {
                this.defaultNew_venVersionSelect();
                this.formDiv.classList.remove('hide');
                $(this.new_venVersionSelect).change();
            } else {
                this.result.renderError(null);
            }
        }
    }

    sortRecordsByVersion(record_a, record_b) {
        if (this.model.data['os_content'][record_a].software_version<this.model.data['os_content'][record_b].software_version) {
            return 1;
        } else {
            return -1;
        }
    }

    populateVenVersionSelect(event) {
        console.debug('populateVenVersionSelect() invoked!');
        if (this.model.success && this.model.data['os_content']) {
            const sorted_keys = Object.keys(this.model.data['os_content']).sort(this.sortRecordsByVersion.bind(this));
            let itemCounter = 0;
            for (let id in sorted_keys) {
                const item = this.model.data['os_content'][sorted_keys[id]];

                let text = item.software_version;
                if (item.lts) {
                    text += ' (LTS)';
                }

                this.new_venVersionSelect.options.add(new Option(text, item.id));
            }
            if (this.new_venVersionSelect.options.length>0) {
                this.defaultNew_venVersionSelect();
                this.formDiv.classList.remove('hide');
                $(this.new_venVersionSelect).change();
            } else {
                this.result.renderError(null);
            }
        }
    }

    populateVenOsSelect() {
        console.debug('populateVenOsSelect() invoked!');
        if (this.model.data['os_content'] && this.model.data['os_content']) {
            const osNames = [];
            for (let venVersionId in this.model.data['os_content']) {
                const record = this.model.data['os_content'][venVersionId];
                if (record.os_matrix && record.os_matrix.length>0) {
                    const osMatrixForEachHandler = function(os_record) {
                        if (osNames.indexOf(os_record.name) == -1) {
                            osNames.push(os_record.name);
                        }
                    }
                    record.os_matrix.forEach(osMatrixForEachHandler);
                } else {
                    this.result.renderError(null);
                    break;
                }
            }
            const osNamesForEachHandler = function(osName) {
                this.new_venOsSelect.options.add(new Option(osName, osName));
            }
            console.log('this.venOsSelect',this.new_venOsSelect);
            while (this.new_venOsSelect.children.length > 0) {
                this.new_venOsSelect.removeChild(this.new_venOsSelect.children[0])
            }
            osNames.sort().forEach(osNamesForEachHandler.bind(this));
            this.formDiv.classList.remove('hidden');

            this.defaultVenOsSelect();
        }
    }

    defaultNew_venVersionSelect() {
        let found = false;
        if (location.hash && location.hash.length>1) {
            const record = this.model.getRecordByVersion(location.hash.substring(1));
            if (record) {
                for (let i=0;i<this.new_venVersionSelect.options.length;i++) {
                    if (this.new_venVersionSelect.options[i].text===record.software_version) {
                        found = true;
                        this.new_venVersionSelect.options[i].selected = true;
                        break;
                    }
                }
            }
        }

        if (!found) {
            this.new_venVersionSelect.options.selectedIndex = 0;
        }
    }

    defaultVenOsSelect() {
        if (location.hash && location.hash.length>0) {
            // const serializedText = unescape(location.hash.substring(1));
            const serializedText = decodeURIComponent(location.hash.substring(1));
console.debug(`» serializedText: ${serializedText}`);
            const parts = serializedText.split('/');
            const venOses = (parts.length>1) ? parts[1].split(',') : null;
            if (this.new_venOsSelect.options.length>0 && venOses && venOses.length>0) {
                for (let i=0;i<this.new_venOsSelect.options.length;i++) {
                    if (venOses.indexOf(this.new_venOsSelect.options[i].value)>=0) {
                        this.new_venOsSelect.options[i].selected = true;
                    }
                }
            }
        }
    }

    trackAnalytic() {
        if (IllumioSupportUtils && this.new_venVersionSelect.selectedIndex>=0) {
            const eventLabel = this.new_venVersionSelect.options[this.new_venVersionSelect.selectedIndex].text;
            console.debug(`eventLabel: ${eventLabel}`);
            IllumioSupportUtils.trackGaEvent('OS Support', 'New_ven', eventLabel);
        }

        const qs = IllumioSupportUtils.getJsonFromUrl(location.href);
        if (qs && qs['source']) {
            IllumioSupportUtils.trackGaEvent('OS Support', 'New_ven Redirect', qs['source'])
            console.debug('Tracked New_ven redirect');
        }
    }
}

export class New_venOsSupportController {
    constructor(model, view) {
        this.model = model;
        this.view = view;
    }
}

export class New_venOsSupportResult {
    constructor() {
        this.new_venContent = document.getElementById('new_venContent');
    }

        /**
         * Public method
         */
        render(record, compatibility) {
            //console.log('record',record);
            //console.log('compatibility',compatibility);
            this.new_venContent.innerHTML = this.createCompatibilityTable(record, compatibility);
            this.new_venContent.innerHTML += record.view;

            this.updateTables();

            this.updateHeading(record);
        }

        /**
         * Public method
         */
        renderError(message) {
            if (!message) {
                message = `We're sorry that we have experienced technical difficulties in retrieving the content. Please try again later.`;
            }
            this.new_venContent.innerHTML = message;
        }

    createCompatibilityTable(record, compatibility) {
        let compatability_html = "<h2>COMPATIBILITY</h2>";
        compatability_html += "<table class='ilo-tabular'><tbody><tr><th>Software type</th><th>Version</th></tr><tr><td>PCE</td><td><ul>";
        for (let i in compatibility) {
            compatability_html += `<li>${compatibility[i]}</li>`;
        }
        compatability_html += "</ul></tr></tbody></table>";
        //console.log('finished compat table', compatability_html)
        return compatability_html;
    }

    // This code assumes that the last item in the table is the qualified header, and will add the qualified class to the 2nd last column
    updateTables() {
        const tables = $("table");
        //console.log('update tables tables :',tables)
        tables.addClass('ilo-tabular');

        const table = tables[1];
        //console.log('update tables table :',table)
        const tbody = (table.children[1]) ? table.children[1] : null;
        const header = (tbody.children[0]) ? tbody.children[0] : null;
        // Check if the header has 3 items for backwards compatability
        if (!header.children[2]) {
            return;
        }
        table.style.width = "";

        // There is an unneccasary colgroup in the HTML here
        table.removeChild(table.children[0]);

        // Delete the "qualified" header then grab the rest of it
        //header.removeChild(header.children[2])

        // var index = 1
        // var versions = []
        // var version_to_replace = tbody.children;
        // console.log('tbody.children[index].children.length',tbody.children[index].children.length)
        // while(tbody.children[index]) {
        //     if (tbody.children[index].children.length == 5) {
        //         console.log('inside the if statement')
        //         var qualified_index = 2
        //         tbody.children[index].removeChild(tbody.children[index].children[qualified_index])
        //         versions.push(tbody.children[index].children[qualified_index-1].innerText)
        //         version_to_replace = tbody.children[index].children[qualified_index-1]
        //         index += 1
        //     } else {
        //         console.log('inside the else statement')
        //         var qualified_index = 1
        //         versions.push(tbody.children[index].children[qualified_index-1].innerText)
        //         tbody.removeChild(tbody.children[index])
        //     }
        // }

        // var new_versions_to_replace_html = '<ul>';
        // for (var i = 0; i < versions.length; i++) {
        //     new_versions_to_replace_html += '<li>' + versions[i] + '</li>';
        // }
        // new_versions_to_replace_html += '</ul>';
        // console.log('new_versions_to_replace_html', new_versions_to_replace_html)

        // version_to_replace.innerHTML = new_versions_to_replace_html
    }

    updateHeading(record) {
        const sections = $('.sectionMacroRow');
        for (let i=1;i<sections.length;i++) {
            sections[i].outerHTML += "<br>";
        }

        const headings = document.getElementsByTagName('h2');
        for (let i=0;i<headings.length;i++) {
            headings[i].textContent += ` for Illumio VEN ${record.software_version}`;
            console.debug(headings[i].textContent);
        }
    }
}

